import { SvgIcon, SvgIconProps } from "@mui/material";

export const LeftRightArrowIconChip = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M15 6.667 18.333 10 15 13.334M5.001 6.667 1.668 10l3.333 3.334M6.668 10h.008M10 10h.008M13.332 10h.008"
      />
    </svg>
  </SvgIcon>
);
